import React from "react";
import { Navigate } from "react-router-dom";
import { useFlags } from "src/clients/launchDarkly";
import ComplianceOverview from "./ComplianceOverview";
import { CategoryMetadataProvider } from "src/providers/CategoryMetadataContext";

const CompliancePage = () => {
  const { complianceToolVisible } = useFlags();

  if (complianceToolVisible !== true) {
    return <Navigate to="/" replace />;
  }

  return (
    <CategoryMetadataProvider>
      <ComplianceOverview />
    </CategoryMetadataProvider>
  );
};

export default CompliancePage;
